import AuthRoute from "shared/routes/authRoute";
import Toast from "shared/components/common/toast";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import "shared/utils/theme.scss";
import "tippy.js/dist/tippy.css";
import "./App.scss";

function App() {
  const {
    theme: { theme },
  } = useSelector((state: any) => state?.root);
  useEffect(() => {
    document.documentElement.setAttribute("theme-mode", theme);
  }, [theme]);
  return (
    <div className="App">
      <AuthRoute />
      <Toast />
    </div>
  );
}

export default App;
